import type { AnalyticsAdapter } from "./AnalyticsAdapter";

interface ConsentWriter {
  decline: () => void;
}

/**
 * Records the refusal as a single anonymous event before external tracking is
 * switched off, so the funnel can tell "declined analytics" from "closed the
 * game". If the PostHog SDK has not finished loading yet, the event is still in
 * the deferred buffer and `optOut` discards it - an early refusal stays invisible.
 */
export function declineAnalytics(adapter: AnalyticsAdapter, consent: ConsentWriter): void {
  adapter.track("consent_declined", undefined, { immediate: true });
  consent.decline();
  adapter.optOut();
}
